import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import Upload from "@/pages/Upload";
import Result from "@/pages/Result";
import Shipments from "@/pages/Shipments";
import AuditTrail from "@/pages/AuditTrail";
import Settings from "@/pages/Settings";

const Protected = ({ children, roles, allowPwChange }) => {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && !allowPwChange) return <Navigate to="/change-password" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<Protected allowPwChange><ChangePassword /></Protected>} />

            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/upload" element={
                <Protected roles={["admin", "finance"]}><Upload /></Protected>
              } />
              <Route path="/shipments" element={<Shipments />} />
              <Route path="/shipments/:reference" element={<Result />} />
              <Route path="/audit" element={
                <Protected roles={["admin"]}><AuditTrail /></Protected>
              } />
              <Route path="/settings" element={
                <Protected roles={["admin"]}><Settings /></Protected>
              } />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
